import { ClientsPage } from '../pages/Clients.page';
import { TestersPage } from '../pages/Testers.page';
import { AdminsPage } from '../pages/Admins.page';
import { CollaboratorsPage } from '../pages/Collaborators.page';

export const AllTabsWrapper = () => {
  return (
    <>
      <ClientsPage />
      <TestersPage />
      <AdminsPage />
      <CollaboratorsPage />
    </>
  );
};
